import { useEffect, useState } from 'react'
import { usePrevious } from '@/CandidateExperience/hooks'

import { NOTIFICATION_ID } from '../PageLayout'

const useToolbarNotificationHeight = () => {
  const [toolbarNotificationHeight, setToolbarNotificationHeight] = useState(null)

  const prevToolbarNotificationHeight = usePrevious(toolbarNotificationHeight)
  const shouldCaptureNotificationHeight = prevToolbarNotificationHeight === null
  useEffect(() => {
    const notification = document.getElementById(NOTIFICATION_ID)
    if (!notification) return

    setToolbarNotificationHeight(notification.clientHeight)
  }, [shouldCaptureNotificationHeight])

  return toolbarNotificationHeight || 0
}

export default useToolbarNotificationHeight
